import {
  STORY_NPC_FACE_RANGE_TILES,
  STORY_NPC_TALK_RANGE_TILES,
  tileDistance,
  type StoryDirection,
  type StoryNpc,
} from '@rdd/contracts'

/**
 * Os NPCs no cliente (modo_historia_mundos/05#HM-001). docs/21 secao 12. Logica pura: a cena le daqui para onde
 * cada um olha e com quem o jogador pode conversar.
 *
 * O NPC nao esta no estado da sala: cada cliente calcula a virada pela posicao do PROPRIO jogador.
 */

export type PlacedNpc = { npc: StoryNpc; x: number; y: number }

type Tile = { x: number; y: number }

/** A altura do NPC em relacao ao tile de 32 px: os sprites do IDLE FORCE tem ~100 px, e o jogador, 3 tiles. */
export const NPC_SCALE_PER_32PX = 0.85

/**
 * Para onde o NPC olha: para o jogador, se ele esta a ate `STORY_NPC_FACE_RANGE_TILES`, pelo eixo em que esta
 * mais longe; senao, para a direcao dele.
 */
export function npcFacing(npc: PlacedNpc, player: Tile): StoryDirection {
  if (tileDistance(npc, player) > STORY_NPC_FACE_RANGE_TILES) return npc.npc.facing
  const dx = player.x - npc.x
  const dy = player.y - npc.y
  if (dx === 0 && dy === 0) return npc.npc.facing
  if (Math.abs(dx) > Math.abs(dy)) return dx > 0 ? 'right' : 'left'
  return dy > 0 ? 'down' : 'up'
}

/** O NPC mais perto ao alcance da conversa, ou `undefined`. Empate fica com o primeiro do mapa. */
export function npcInReach(npcs: readonly PlacedNpc[], player: Tile): PlacedNpc | undefined {
  let best: PlacedNpc | undefined
  for (const placed of npcs) {
    const distance = tileDistance(placed, player)
    if (distance > STORY_NPC_TALK_RANGE_TILES) continue
    if (best === undefined || distance < tileDistance(best, player)) best = placed
  }
  return best
}

/** Os tiles em volta do NPC, de onde se conversa com ele: o toque num NPC longe anda ate um deles. */
export function tilesAround(npc: Tile): Tile[] {
  const around: Tile[] = []
  for (let dy = -STORY_NPC_TALK_RANGE_TILES; dy <= STORY_NPC_TALK_RANGE_TILES; dy++)
    for (let dx = -STORY_NPC_TALK_RANGE_TILES; dx <= STORY_NPC_TALK_RANGE_TILES; dx++)
      if (dx !== 0 || dy !== 0) around.push({ x: npc.x + dx, y: npc.y + dy })
  return around
}
